/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum RegistrationStatus {
  EMAIL_EXISTS = "EMAIL_EXISTS",
  SUCCESS = "SUCCESS",
  USER_EXISTS = "USER_EXISTS",
  WRONG_USERNAME = "WRONG_USERNAME",
}